import axios, { AxiosError } from 'axios';

export const formatDate = (date: Date): string => {
  // @ts-ignore
  if (!date || isNaN(date)) return date;
  const zero = (value: string | number): string => {
    if (Number(value) < 10) return `0${value}`;
    return String(value);
  };
  const day = zero(date.getDate());
  const month = zero(date.getMonth() + 1);
  const year = date.getFullYear();
  const hour = zero(date.getHours());
  const minute = zero(date.getMinutes());
  const second = zero(date.getSeconds());

  return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
};

export const getChainName = (chainId: string | undefined): string => {
  switch (chainId) {
    case '0x1':
      return 'Ethereum Mainnet';
    case '0x3':
      return 'Ropsten Testnet';
    case '0x4':
      return 'Rinkeby Testnet';
    case '0x5':
      return 'Goerli Testnet';
    case '0x2a':
      return 'Kovan Testnet';
    case '0x61':
      return 'Binance Testnet';
    default:
      return 'Network';
  }
};

export const stringToNumberOrFalse = (input: any): false | number => {
  if (typeof input === 'number') return input;
  if (typeof input !== 'string') return false;
  const bool = !isNaN(+input) && !isNaN(parseFloat(input));
  if (!bool) return false;
  return +input;
};

export const minifyHash = (input: string): string => {
  if (input.length < 9) return input;
  return `${input.substring(0, 6)}...${input.substring(input.length - 2)}`;
};

export const ejectErrorMessage = (
  error: string | AxiosError
): string | undefined => {
  if (typeof error === 'string') return error;
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as any;
    if (data?.message) return data.message;
  }
  if (error?.message) return error.message;
  return undefined;
};
